import { FontEnum } from "../../../../SharedComponents/utils/enums/FontEnum";
import { getCreatedAtString } from "../../../utils/helpers/notificationsHelpers/getCreatedAtString";

const NotificationsTableRow = ({
    notification
}) => {

    const dateString = getCreatedAtString(notification.createdAt);

    return (
        <div style={styles.mainContainer}>
            <div style={styles.upperRow}>
                <p style={styles.titleText}>
                    {notification.title}
                </p>

                <p style={styles.createdAtText}>
                    {dateString}
                </p>
            </div>

            <div>
                <p style={styles.messageText}>
                    {notification.message}
                </p>
            </div>
        </div>
    );
};

export default NotificationsTableRow;

const styles = {
    mainContainer: {
        display: 'flex',
        flexDirection: 'column',
        gap: 4,
        paddingTop: 10,
        paddingBottom: 10,
        borderBottom: "1px solid rgba(0, 0, 0, 0.12)"
    },
    upperRow: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
    },
    titleText: {
        fontFamily: FontEnum.TITILIUM_WEB,
        fontWeight: 600,
        fontSize: "16px",
        color: "rgba(0, 0, 0, 0.87)"
    },
    createdAtText: {
        fontFamily: FontEnum.TITILIUM_WEB,
        fontWeight: 400,
        fontSize: "16px",
        color: "rgba(0, 0, 0, 0.6)"
    },
    messageText: {
        fontFamily: FontEnum.TITILIUM_WEB,
        fontSize: "16px",
        fontWeigth: 400,
        color: "rgba(0, 0, 0, 0.87)"
    },

};